import Modal from './modal.vue'

const Plugin = {
  install (Vue, options = {}) {
    /**
     * Makes sure that plugin can be insstalled only once
     */
    if (this.installed) {
      return
    }

    this.installed = true
    this.event = new Vue()
    /**
     * Plugin API
     */
    Vue.prototype.$modal = {
      open(name, params) {
        Plugin.event.$emit('open', name, params)
      },

      close(name, params) {
        Plugin.event.$emit('close', name, params)
      },

      toggle(name, params) {
        Plugin.event.$emit('toggle', name, params)
      }
    }

    Vue.component('vgb-modal', Modal)
  }
}

export default Plugin



// WEBPACK FOOTER //
// ./resources/assets/front/js/components/vgb-modal/index.js